export function getNameFieldBasedOnLang(
  lang: string
): "name" | "name_fi" | "name_se" {
  if (lang === "se") return "name_se";
  if (lang === "fi") return "name_fi";
  if (lang === "en") return "name";
  return "name";
}
